<template>
  <div class="generateClass">
    <el-container>
      <el-main>
        <el-tabs type="card" style="margin-top:20px;" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="周" name="first">
            <el-table
              v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              class="teacherTable"
              :data="tableData"
              border
              style="width: 100%;"
            >
              <el-table-column prop="period" label="时间段"></el-table-column>
              <el-table-column prop="campusName" label="周一">
                <template slot-scope="scope">
                  <draggable
                    v-model="scope.row.monday"
                    :group="{ put: true}"
                    :move="allow"
                    @end="draggableEnd"
                  >
                    <div v-for="(item,index) in scope.row.monday" :key="index">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">{{item.subjectCourse.name}}</div>
                          <div
                            class="calendar-solt2"
                          >上课时间:{{item.schedulePeriod.beginTime}}-{{item.schedulePeriod.endTime}}</div>
                          <div class="calendar-solt2">
                            上课老师:{{item.teacher.name}}
                            <div
                              @click="editTeacher(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{item.classroom.name}}
                            <div
                              @click="editClassRoom(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          <span v-if="item.classInfo.name">{{item.classInfo.name}}</span>
                          {{item.subjectCourse.name}}
                        </div>
                      </el-tooltip>
                    </div>
                  </draggable>
                </template>
              </el-table-column>
              <el-table-column prop="campusName" label="周二">
                <template slot-scope="scope">
                  <draggable
                    v-model="scope.row.tuesday"
                    :group="{put: true}"
                    :move="allow"
                    @end="draggableEnd"
                  >
                    <div v-for="(item,index) in scope.row.tuesday" :key="index">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">{{item.subjectCourse.name}}</div>
                          <div
                            class="calendar-solt2"
                          >上课时间:{{item.schedulePeriod.beginTime}}-{{item.schedulePeriod.endTime}}</div>
                          <div class="calendar-solt2">
                            上课老师:{{item.teacher.name}}
                            <div
                              @click="editTeacher(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{item.classroom.name}}
                            <div
                              @click="editClassRoom(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          <span v-if="item.classInfo.name">{{item.classInfo.name}}</span>
                          {{item.subjectCourse.name}}
                        </div>
                      </el-tooltip>
                    </div>
                  </draggable>
                </template>
              </el-table-column>
              <el-table-column prop="campusName" label="周三">
                <template slot-scope="scope">
                  <draggable
                    v-model="scope.row.wednesday"
                    :group="{put: true}"
                    :move="allow"
                    @end="draggableEnd"
                  >
                    <div v-for="(item,index) in scope.row.wednesday" :key="index">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">{{item.subjectCourse.name}}</div>
                          <div
                            class="calendar-solt2"
                          >上课时间:{{item.schedulePeriod.beginTime}}-{{item.schedulePeriod.endTime}}</div>
                          <div class="calendar-solt2">
                            上课老师:{{item.teacher.name}}
                            <div
                              @click="editTeacher(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{item.classroom.name}}
                            <div
                              @click="editClassRoom(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          <span v-if="item.classInfo.name">{{item.classInfo.name}}</span>
                          {{item.subjectCourse.name}}
                        </div>
                      </el-tooltip>
                    </div>
                  </draggable>
                </template>
              </el-table-column>
              <el-table-column prop="campusName" label="周四">
                <template slot-scope="scope">
                  <draggable
                    v-model="scope.row.thursday"
                    :group="{ put: true}"
                    :move="allow"
                    @end="draggableEnd"
                  >
                    <div v-for="(item,index) in scope.row.thursday" :key="index">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">{{item.subjectCourse.name}}</div>
                          <div
                            class="calendar-solt2"
                          >上课时间:{{item.schedulePeriod.beginTime}}-{{item.schedulePeriod.endTime}}</div>
                          <div class="calendar-solt2">
                            上课老师:{{item.teacher.name}}
                            <div
                              @click="editTeacher(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{item.classroom.name}}
                            <div
                              @click="editClassRoom(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          <span v-if="item.classInfo.name">{{item.classInfo.name}}</span>
                          {{item.subjectCourse.name}}
                        </div>
                      </el-tooltip>
                    </div>
                  </draggable>
                </template>
              </el-table-column>
              <el-table-column prop="campusName" label="周五">
                <template slot-scope="scope">
                  <draggable
                    v-model="scope.row.friday"
                    :group="{ put: true}"
                    :move="allow"
                    @end="draggableEnd"
                  >
                    <div v-for="(item,index) in scope.row.friday" :key="index">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">{{item.subjectCourse.name}}</div>
                          <div
                            class="calendar-solt2"
                          >上课时间:{{item.schedulePeriod.beginTime}}-{{item.schedulePeriod.endTime}}</div>
                          <div class="calendar-solt2">
                            上课老师:{{item.teacher.name}}
                            <div
                              @click="editTeacher(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{item.classroom.name}}
                            <div
                              @click="editClassRoom(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          <span v-if="item.classInfo.name">{{item.classInfo.name}}</span>
                          {{item.subjectCourse.name}}
                        </div>
                      </el-tooltip>
                    </div>
                  </draggable>
                </template>
              </el-table-column>
              <el-table-column prop="campusName" label="周六">
                <template slot-scope="scope">
                  <draggable
                    v-model="scope.row.saturday"
                    :group="{put: true}"
                    :move="allow"
                    @end="draggableEnd"
                  >
                    <div v-for="(item,index) in scope.row.saturday" :key="index">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">{{item.subjectCourse.name}}</div>
                          <div
                            class="calendar-solt2"
                          >上课时间:{{item.schedulePeriod.beginTime}}-{{item.schedulePeriod.endTime}}</div>
                          <div class="calendar-solt2">
                            上课老师:{{item.teacher.name}}
                            <div
                              @click="editTeacher(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{item.classroom.name}}
                            <div
                              @click="editClassRoom(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          <span v-if="item.classInfo.name">{{item.classInfo.name}}</span>
                          {{item.subjectCourse.name}}
                        </div>
                      </el-tooltip>
                    </div>
                  </draggable>
                </template>
              </el-table-column>
              <el-table-column prop="campusName" label="周日">
                <template slot-scope="scope">
                  <draggable
                    v-model="scope.row.sunday"
                    :group="{put: true}"
                    :move="allow"
                    @end="draggableEnd"
                  >
                    <div v-for="(item,index) in scope.row.sunday" :key="index">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">{{item.subjectCourse.name}}</div>
                          <div
                            class="calendar-solt2"
                          >上课时间:{{item.schedulePeriod.beginTime}}-{{item.schedulePeriod.endTime}}</div>
                          <div class="calendar-solt2">
                            上课老师:{{item.teacher.name}}
                            <div
                              @click="editTeacher(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{item.classroom.name}}
                            <div
                              @click="editClassRoom(item,scope.row.schedulePeriodId)"
                              class="generateClass-icon el-icon-edit"
                            ></div>
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          <span v-if="item.classInfo.name">{{item.classInfo.name}}</span>
                          {{item.subjectCourse.name}}
                        </div>
                      </el-tooltip>
                    </div>
                  </draggable>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="月" name="second">
            <el-calendar v-model="currentDate" :key="currentDate.split('-')[0] + currentDate.split('-')[1] + currentDate.split('-')[2]">
              <template slot="dateCell" slot-scope="{date, data}">
                <div
                  :class="data.isSelected ? 'is-selected' : ''"
                >{{ data.day.split('-').slice(2)[0] }}</div>
                <div v-for="(item,index) in calendarData" :key="index">
                  <div
                    v-if="(item.date.split('-')[1]).indexOf(data.day.split('-').slice(1)[0])!=-1"
                  >
                    <div
                      v-if="(item.date.split('-')[2]).indexOf(data.day.split('-').slice(2).join('-'))!=-1"
                    >
                      <!-- <draggable
                        v-model="item.scheduleList"
                        style="min-height:100px"
                        :class="data.day"
                        :group="{put: true}"
                        :move="allow2"
                        @start="start"
                        @end="draggableEnd2"
                      > -->
                        <div v-for="(items,indexs) in item.scheduleList" :key="indexs" :class="data.day">
                          <el-tooltip class="item" effect="light" placement="top">
                            <div slot="content">
                              <div class="calendar-solt1">{{items.subjectCourse.name + '-第' + items.sequence + '课时'}}</div>
                              <div
                                class="calendar-solt2"
                              >上课时间:{{items.schedulePeriod.beginTime}}-{{items.schedulePeriod.endTime}}</div>
                              <div class="calendar-solt2">上课老师:{{items.teacher.name}}</div>
                              <div class="calendar-solt2">上课教室:{{items.classroom.name}}</div>
                            </div>
                            <div class="classManage-study1" type="size">
                              {{items.classInfo.name}}
                              {{items.subjectCourse.name}}
                            </div>
                          </el-tooltip>
                        </div>
                      <!-- </draggable> -->
                    </div>
                  </div>
                </div>
                
              </template>
            </el-calendar>
          </el-tab-pane>
        </el-tabs>
        <!-- <el-button v-if="scheduleStateNameTrue===false" class="generateClass-button" @click="regenerateSimpleClassInfoSchedule">重新生成</el-button> -->
        <el-button class="generateClass-button" type="primary" @click="batchAddScheduleInfo" :loading="batchAddScheduleInfoBlock">保存课表</el-button>
      </el-main>

      <el-dialog title="修改上课老师" :visible.sync="teacherDialogVisible" width="30%">
        <el-form label-width="80px">
          <el-form-item label="上课老师" prop="teacherId">
            <el-select placeholder="请选择上课老师" style="width:90%" v-model="editTeacherId" clearable>
              <el-option
                v-for="item in teacherList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="teacherDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editTeacherIdTrue">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="修改上课教室" :visible.sync="classRoomDialogVisible" width="30%">
        <el-form label-width="80px">
          <el-form-item label="上课教室" prop="classroomId">
            <el-select placeholder="请选择上课教室" style="width:90%" v-model="editClassroomId" clearable>
              <el-option
                v-for="item in classroomList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="classRoomDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editClassroomIdTrue">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
  <!-- <div>
  <draggable element="ul" v-model="listdata">
   <li v-for="item in listdata">{{item.name}}</li>
  </draggable>
  </div>-->
</template>

<script>
import draggable from "vuedraggable";
import Draggable from '../examView/draggable.vue';
export default {
  name: "draggabletest",
  components: {
    draggable
    // Draggable
  },
  data() {
    return {
      batchAddScheduleInfoBlock: false,
      activeName: "first",
      currentDate: new Date(),
      calendarData: [],
      element: {},
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: [],
      scheduleStateNameTrue: false,
      teacherDialogVisible: false,
      classRoomDialogVisible: false,
      classroomList: [],
      editClassroomId: "",
      editClassroomForm: {},
      teacherList: [],
      oldData: '',
      newData: '',
      editTeacherId: "",
      editTeacherForm: {},
      loading: false,
      tableData: [
        {
          listdata1: [
            {
              id: 1,
              name: "09:00 经济法基础1"
            },
            {
              id: 2,
              name: "09:00 经济法基础2"
            },
            {
              id: 3,
              name: "09:00 经济法基础3"
            }
          ],
          listdata2: [
            {
              id: 4,
              name: "09:00 经济法基础4"
            },
            {
              id: 5,
              name: "09:00 经济法基础5"
            },
            {
              id: 6,
              name: "09:00 经济法基础6"
            }
          ]
        }
      ]
    };
  },
  methods: {
    getData() {
      this.calendarData = JSON.parse(
        localStorage.getItem("jump")
      ).monthScheduleInfoList;
      this.tableData = JSON.parse(
        localStorage.getItem("jump")
      ).weekScheduleInfoList;
      this.currentDate = this.calendarData[0].date;
      console.log("calendarData", this.calendarData);
    },
    getscheduleStateNameTrue(){
      let obj = JSON.parse(localStorage.getItem("jump"));
      for(let item in obj){
        if(item.scheduleStateName !== "未排课"){
        }else{
          this.scheduleStateNameTrue = true;
        }
      }
    },
    editTeacher(item, schedulePeriodId) {
      this.editTeacherForm = {};
      this.teacherList = item.teacherList;
      this.editTeacherId = item.teacherId;
      this.editTeacherForm = {
        classInfoId: item.classInfoId,
        originalScheduleInfo: {
          weekday: item.weekday,
          date: item.date,
          schedulePeriodId: schedulePeriodId,
          classroomId: item.classroomId,
          teacherId: item.teacherId
        },
        presentScheduleInfo: {
          weekday: item.weekday,
          date: item.date,
          schedulePeriodId: schedulePeriodId,
          classroomId: item.classroomId,
          teacherId: item.teacherId
        }
      };
      this.teacherDialogVisible = true;
    },
    editClassRoom(item, schedulePeriodId) {
      this.editClassroomForm = {};
      this.classroomList = item.classroomList;
      this.editClassroomId = item.classroomId;
      this.editClassroomForm = {
        classInfoId: item.classInfoId,
        originalScheduleInfo: {
          weekday: item.weekday,
          date: item.date,
          schedulePeriodId: schedulePeriodId,
          classroomId: item.classroomId,
          teacherId: item.teacherId
        },
        presentScheduleInfo: {
          weekday: item.weekday,
          date: item.date,
          schedulePeriodId: schedulePeriodId,
          classroomId: item.classroomId,
          teacherId: item.teacherId
        }
      };
      this.classRoomDialogVisible = true;
    },
    regenerateSimpleClassInfoSchedule() {
      this.$confirm("是否确认重新生成？", "系统消息", {
        type: "warning"
      }).then(() => {
        let obj = JSON.parse(localStorage.getItem("classDetail"));
        let ids = [];
        for (let item of obj) {
          ids.push(item.id);
        }
        this.api.classInfo
          .regenerateSimpleClassInfoSchedule({ ids })
          .then(result => {
            if (result.success) {
              let obj2 = result.data;
              localStorage.setItem("jump", JSON.stringify(obj2));
              this.$message.success(result.message);
              this.getData();
            } else {
              this.$message.error(result.message);
            }
          });
      });
    },
    batchAddScheduleInfo() {
      if(this.batchAddScheduleInfoBlock){
        return false;
      }
      this.batchAddScheduleInfoBlock = true;
      this.$confirm("是否确认保存课表？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.scheduleInfo
          .batchAddScheduleInfo({
            cacheId: String(JSON.parse(localStorage.getItem("jump")).cacheId)
          })
          .then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.$router.push({ path: "/classManage" });
            } else {
              this.batchAddScheduleInfoBlock = false;
              this.$message.error(result.message);
            }
          });
      });
    },
    allow(evt) {
      this.element = evt.draggedContext.element;
    },
    allow2(evt) {
      this.element = evt.draggedContext.element;
    },
    draggableEnd(evt) {
      this.findData();
    },
    start(evt) {
      // console.log('evt11111111', evt)
    },
    draggableEnd2(evt) {
      this.oldData = evt.item.className;
      this.newData = evt.to.className;
      this.findData2()
    },
    findData2() {
      let element = this.element;
      console.log('1', element)
      let obj = {
        classInfoId: element.classInfoId,
        originalScheduleInfo: {
          date: this.oldData,
          schedulePeriodId: element.schedulePeriodId,
          classroomId: element.classroomId,
          teacherId: element.teacherId
        },
        presentScheduleInfo: {
          date: this.newData,
          schedulePeriodId: element.schedulePeriodId,
          classroomId: element.schedulePeriodId,
          teacherId: element.schedulePeriodId
        }
      };
      this.microTransferClass(obj);
    },
    findData() {
      let element = this.element;
      let temTable = JSON.parse(JSON.stringify(this.tableData));
      bbq: for (let item of temTable) {
        for (let items of item.monday) {
          if (
            items.weekday === element.weekday &&
            items.classroomId === element.classroomId &&
            items.classInfoId === element.classInfoId &&
            items.schedulePeriodId === element.schedulePeriodId
          ) {
            let obj = {
              classInfoId: items.classInfoId,
              originalScheduleInfo: {
                weekday: element.weekday,
                date: element.date,
                schedulePeriodId: element.schedulePeriodId,
                classroomId: element.classroomId,
                teacherId: element.teacherId
              },
              presentScheduleInfo: {
                weekday: 2,
                schedulePeriodId: item.schedulePeriodId,
                classroomId: items.classroomId,
                teacherId: items.teacherId
              }
            };
            this.microTransferClass(obj);
            break bbq;
          }
        }
        for (let items of item.tuesday) {
          if (
            items.classInfoId === element.classInfoId &&
            items.weekday === element.weekday &&
            items.classroomId === element.classroomId &&
            items.schedulePeriodId === element.schedulePeriodId
          ) {
            let obj = {
              classInfoId: element.classInfoId,
              originalScheduleInfo: {
                weekday: element.weekday,
                date: element.date,
                schedulePeriodId: element.schedulePeriodId,
                classroomId: element.classroomId,
                teacherId: element.teacherId
              },
              presentScheduleInfo: {
                weekday: 3,
                schedulePeriodId: item.schedulePeriodId,
                classroomId: items.classroomId,
                teacherId: items.teacherId
              }
            };
            console.log("33333333333");
            this.microTransferClass(obj);
            break bbq;
          }
        }
        for (let items of item.wednesday) {
          if (
            items.classInfoId === element.classInfoId &&
            items.weekday === element.weekday &&
            items.classroomId === element.classroomId &&
            items.schedulePeriodId === element.schedulePeriodId
          ) {
            let obj = {
              classInfoId: element.classInfoId,
              originalScheduleInfo: {
                weekday: element.weekday,
                date: element.date,
                schedulePeriodId: element.schedulePeriodId,
                classroomId: element.classroomId,
                teacherId: element.teacherId
              },
              presentScheduleInfo: {
                weekday: 4,
                schedulePeriodId: item.schedulePeriodId,
                classroomId: items.classroomId,
                teacherId: items.teacherId
              }
            };
            console.log("44444444");
            this.microTransferClass(obj);
            break bbq;
          }
        }
        for (let items of item.thursday) {
          if (
            items.classInfoId === element.classInfoId &&
            items.weekday === element.weekday &&
            items.classroomId === element.classroomId &&
            items.schedulePeriodId === element.schedulePeriodId
          ) {
            let obj = {
              classInfoId: element.classInfoId,
              originalScheduleInfo: {
                weekday: element.weekday,
                date: element.date,
                schedulePeriodId: element.schedulePeriodId,
                classroomId: element.classroomId,
                teacherId: element.teacherId
              },
              presentScheduleInfo: {
                weekday: 5,
                schedulePeriodId: item.schedulePeriodId,
                classroomId: items.classroomId,
                teacherId: items.teacherId
              }
            };
            console.log("555555555");
            this.microTransferClass(obj);
            break bbq;
          }
        }
        for (let items of item.friday) {
          if (
            items.classInfoId === element.classInfoId &&
            items.weekday === element.weekday &&
            items.classroomId === element.classroomId &&
            items.schedulePeriodId === element.schedulePeriodId
          ) {
            let obj = {
              classInfoId: element.classInfoId,
              originalScheduleInfo: {
                weekday: element.weekday,
                date: element.date,
                schedulePeriodId: element.schedulePeriodId,
                classroomId: element.classroomId,
                teacherId: element.teacherId
              },
              presentScheduleInfo: {
                weekday: 6,
                schedulePeriodId: item.schedulePeriodId,
                classroomId: items.classroomId,
                teacherId: items.teacherId
              }
            };
            console.log("666666666");
            this.microTransferClass(obj);
            break bbq;
          }
        }
        for (let items of item.saturday) {
          if (
            items.classInfoId === element.classInfoId &&
            items.weekday === element.weekday &&
            items.classroomId === element.classroomId &&
            items.schedulePeriodId === element.schedulePeriodId
          ) {
            let obj = {
              classInfoId: element.classInfoId,
              originalScheduleInfo: {
                weekday: element.weekday,
                date: element.date,
                schedulePeriodId: element.schedulePeriodId,
                classroomId: element.classroomId,
                teacherId: element.teacherId
              },
              presentScheduleInfo: {
                weekday: 7,
                schedulePeriodId: item.schedulePeriodId,
                classroomId: items.classroomId,
                teacherId: items.teacherId
              }
            };
            console.log("7777777");
            this.microTransferClass(obj);
          }
        }
        for (let items of item.sunday) {
          if (
            items.classInfoId === element.classInfoId &&
            items.weekday === element.weekday &&
            items.classroomId === element.classroomId &&
            items.schedulePeriodId === element.schedulePeriodId
          ) {
            let obj = {
              classInfoId: element.classInfoId,
              originalScheduleInfo: {
                weekday: element.weekday,
                date: element.date,
                schedulePeriodId: element.schedulePeriodId,
                classroomId: element.classroomId,
                teacherId: element.teacherId
              },
              presentScheduleInfo: {
                period: item.period,
                weekday: 1,
                schedulePeriodId: item.schedulePeriodId,
                classroomId: items.classroomId,
                teacherId: items.teacherId
              }
            };
            this.microTransferClass(obj);
            break bbq;
          }
        }
      }
    },
    editClassroomIdTrue() {
      this.editClassroomForm.presentScheduleInfo.classroomId = this.editClassroomId;
      this.microTransferClass(this.editClassroomForm);
    },
    editTeacherIdTrue() {
      this.editTeacherForm.presentScheduleInfo.teacherId = this.editTeacherId;
      this.microTransferClass(this.editTeacherForm);
    },
    microTransferClass(obj) {
      obj.cacheId = String(JSON.parse(localStorage.getItem("jump")).cacheId);
      this.api.scheduleInfo.microTransferClass(obj).then(result => {
        if (result.success) {
          this.classRoomDialogVisible = false;
          this.teacherDialogVisible = false;
          // this.getScheduleInfoListCache();
          let obj = result.data;
          obj.cacheId = String(
            JSON.parse(localStorage.getItem("jump")).cacheId
          );
          localStorage.setItem("jump", JSON.stringify(obj));
          this.calendarData = JSON.parse(
            localStorage.getItem("jump")
          ).monthScheduleInfoList;
          this.tableData = JSON.parse(
            localStorage.getItem("jump")
          ).weekScheduleInfoList;
          this.currentDate = this.calendarData[0].date;
        } else {
          this.$message.error(result.message);
          this.classRoomDialogVisible = false;
          this.teacherDialogVisible = false;
          this.calendarData = JSON.parse(
            localStorage.getItem("jump")
          ).monthScheduleInfoList;
          this.tableData = JSON.parse(
            localStorage.getItem("jump")
          ).weekScheduleInfoList;
          this.currentDate = this.calendarData[0].date;
        }
      });
    },
    getScheduleInfoListCache() {
      let obj = {
        cacheId: String(JSON.parse(localStorage.getItem("jump")).cacheId)
      };
      this.api.scheduleInfo.getScheduleInfoListCache(obj).then(result => {
        if (result.success) {
          let obj = result.data;
          obj.cacheId = String(
            JSON.parse(localStorage.getItem("jump")).cacheId
          );
          localStorage.setItem("jump", JSON.stringify(obj));
          this.calendarData = JSON.parse(
            localStorage.getItem("jump")
          ).monthScheduleInfoList;
          this.tableData = JSON.parse(
            localStorage.getItem("jump")
          ).weekScheduleInfoList;
          this.currentDate = this.calendarData[0].date;
          console.log("this.calendarData", this.calendarData);
        } else {
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name === "first") {
        // this.classroomCalendar(
        //   this.currentWeekDate[0],
        //   this.currentWeekDate[1]
        // );
      }
      if (tab.name === "second") {
        // this.classroomCalendar();
      }
    },

    //获取教室列表
    getClassroomList(id) {
      this.api.classroom.getClassroomList({ campusId: id }).then(result => {
        if (result.success) {
          this.classroomList = result.data;
          if (this.classroomList.length === 0) {
            this.$message.error("该校区暂无教室，请添加教室信息");
          }
        } else {
          this.$message.error(result.message);
        }
      });
    }
  },
  watch: {
    tableData(nVal, oVal) {},
    teacherDialogVisible: function(newVal) {
      if (!newVal) {
      } else {
        // this.getTeacherList();
      }
    },
    classRoomDialogVisible: function(newVal) {
      if (!newVal) {
      } else {
        // this.getClassroomList();
      }
    }
  },
  mounted() {
    this.getData();
    this.getscheduleStateNameTrue();
  }
};
</script>

<style scoped>
.generateClass {
  background-color: #fff;
  position: relative;
}
.generateClass-button {
  margin-top: 20px;
}
.classManage-study1 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #4d94ff;
  margin-top: 2px;
  border-left: 2px solid rgba(77, 148, 255, 1);
  background-color: rgba(77, 148, 255, 0.0980392156862745);
  overflow: hidden;
}
.calendar-solt1 {
  font-size: 16px;
  color: #455a64;
  font-weight: 600;
  width: 200px;
}
.calendar-solt2 {
  font-size: 13px;
  margin-top: 10px;
}
.calendar-solt3 {
  border-top: 1px solid #e4e7ed;
  margin-top: 10px;
}
.generateClass-icon {
  font-size: 14px;
  color: #4d94ff;
  margin-right: 20px;
  cursor: pointer;
}
</style>
<style lang="less">
.generateClass {
  .el-calendar-table .el-calendar-day {
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classManage/generateClass.vue